module.exports = __webpack_public_path__ + "static/media/cdu_zxd.709729f5.png";